// @flow
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import Chart, { styles as chartStyles } from '../chart/Chart';

type Props = {
  options: Object,
  width?: number,
  height?: number,
  timeBased: Object,
};

const metrics = [
  { key: 'jobOffers', label: 'Offers' },
  { key: 'jobRequests', label: 'Requests' },
  { key: 'jobs', label: 'Jobs' },
  { key: 'tutors', label: 'Tutors' },
  { key: 'students', label: 'Students' },
  {
    key: 'expiredJobRequestsWithNoOffers',
    label: 'Expired Requests (No Offers)',
  },
  { key: 'expiredJobRequestsWithOffers', label: 'Expired Requests' },
];

const timePeriods = [
  { key: 'today', label: 'Today' },
  { key: 'pastWeek', label: 'Week' },
  { key: 'pastMonth', label: 'Month' },
];

const createData = data => ({
  labels: metrics.map(metric => metric.label),
  datasets: timePeriods.map((period, index) => ({
    label: period.label,
    borderWidth: 1,
    backgroundColor: chartStyles.colours.background[index],
    borderColor: chartStyles.colours.border[index],
    data: metrics.map(metric => data[metric.key][period.key]),
  })),
});

const TimeBasedChart = ({
  options,
  width = 400,
  height = 400,
  timeBased,
}: Props) => {
  const data = createData(timeBased);

  return <Chart width={width} height={height} data={data} options={options} />;
};

// eslint-disable-next-line
graphql`
  fragment TimeBasedChartFragment on MetricTimePeriod {
    today
    yesterday
    pastWeek
    pastMonth
  }
`;

export default createFragmentContainer(TimeBasedChart, {
  timeBased: graphql`
    fragment TimeBasedChart_timeBased on TimeBasedMetric {
      jobRequests {
        ...TimeBasedChartFragment
      }
      jobOffers {
        ...TimeBasedChartFragment
      }
      jobs {
        ...TimeBasedChartFragment
      }
      students {
        ...TimeBasedChartFragment
      }
      tutors {
        ...TimeBasedChartFragment
      }
      expiredJobRequestsWithNoOffers {
        ...TimeBasedChartFragment
      }
      expiredJobRequestsWithOffers {
        ...TimeBasedChartFragment
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/components/home/TimeBasedChart.js